import { kOCNTextColor } from "../constants";
import { QButton } from "./QButton";
import { SetCtxFont } from "../utils/SetCtxFont.js";

export class QSpacingModeButton extends QButton {
  constructor() {
    super();
    this.fMode = null;
    this.fTextColor = kOCNTextColor;
  }

  SetMode(theMode) {
    this.fMode = theMode;
  }

  DoRenderContent(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    //  ctx.font="11px Verdana";
    SetCtxFont(ctx, "11px Verdana");

    var txtFillStyle = this.fTextColor;
    ctx.fillStyle = txtFillStyle;
    ctx.textAlign = "left";
    ctx.textBaseline = "alphabetic";

    var theLabel = this.fMode;
    var txtHOffset = 4;
    var txtHeight = 8;
    var txtVOffset = (this.fHeight - txtHeight) / 2;

    ctx.fillText(
      theLabel,
      this.fHorzOffset + txtHOffset,
      this.fVertOffset + this.fHeight - txtVOffset
    );
  }
}
